import type { TicketDto } from '@planuze/admin-contracts';
import { Button, StatusBadge } from '@planuze/ui';
import { useState } from 'react';
import { useSupportContent } from '../../content/sections/support.js';
import { AssignTicketModal } from './assign-ticket-modal.js';
import { CloseTicketModal } from './close-ticket-modal.js';
import { ConnectionBadge } from './connection-badge.js';
import { priorityTone, statusLabel, statusTone } from './ticket-status.js';

type ConnectionState = 'connecting' | 'open' | 'reconnecting' | 'closed';

interface Props {
  readonly ticket: TicketDto;
  readonly staffId: string;
  readonly connectionState: ConnectionState;
}

export function ChatHeader({ ticket, staffId, connectionState }: Props) {
  const copy = useSupportContent();
  const [assignOpen, setAssignOpen] = useState(false);
  const [closeOpen, setCloseOpen] = useState(false);
  const isClosed = ticket.status === 'closed';
  const mine = ticket.assignedToStaffId === staffId;
  return (
    <header className="flex items-center justify-between border-b border-border bg-card px-4 py-3">
      <div className="space-y-1">
        <h1 className="text-lg font-semibold text-foreground">{ticket.subject}</h1>
        <div className="flex items-center gap-2">
          <StatusBadge variant={statusTone(ticket.status)}>
            {statusLabel(ticket.status, copy.ticketStatusLabels)}
          </StatusBadge>
          <StatusBadge variant={priorityTone(ticket.priority)}>{ticket.priority}</StatusBadge>
          <ConnectionBadge state={connectionState} />
        </div>
      </div>
      {!isClosed && (
        <div className="flex gap-2">
          {!mine && (
            <Button variant="outline" size="sm" onClick={() => setAssignOpen(true)}>
              {copy.chatHeader.assign}
            </Button>
          )}
          <Button variant="destructive" size="sm" onClick={() => setCloseOpen(true)}>
            {copy.chatHeader.close}
          </Button>
        </div>
      )}
      <AssignTicketModal
        open={assignOpen}
        onClose={() => setAssignOpen(false)}
        ticketId={ticket.id}
        staffId={staffId}
      />
      <CloseTicketModal open={closeOpen} onClose={() => setCloseOpen(false)} ticketId={ticket.id} />
    </header>
  );
}
